// extracted by mini-css-extract-plugin
export default {"eventFooterContainer":"EventFooter_eventFooterContainer__JF+ur","columnItem":"EventFooter_columnItem__cmCZM"};